import React from 'react'
import '../courses.css'
import Menubar from '../../home/menubar/Menubar'
import Address from '../../home/footer/Address'
import Carousel from '../../home/carousel/Carousel'
import { editingImg, editingData, editing_gif } from '../../home/data'
import Hower from '../../home/hower/Hower'
import Typewriter from '../../home/lazy loader/Typewriter'
import ScrollToTopProgress from '../../home/header/ScrollToTopProgress'
import Header from '../../home/header/Header'

function Videoediting() {
  const imgUrl = editingImg;
  const txt = editingData;
  const gif = editing_gif;
  return (
    <div>
        <Header/>
        <Menubar/>
        <Carousel imgUrl={imgUrl}/>
        <Hower gif={gif}/>
        <Typewriter txt={txt}/>

        
        <div className='pannel-container'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <p className='panel-title'>ADOBE VIDEO EDITING Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
            <li className='list'>What is ADOBE VIDEO EDITING ?</li>
            <li className='list'>Learning about the Premiere Pro Interface</li>
            <li className='list'>Importing Assets</li>
            <li className='list'>Creating the First Sequence</li>
            <li className='list'>Adding Video Clips to the Timeline</li>
            <li className='list'>Understanding the Timeline Panel</li>
            <li className='list'>Using the Source Monitor to Edit a Clip</li>
            <li className='list'>Trimming Clips on the Timeline</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      <p className='panel-title'>ADOBE VIDEO EDITING Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          	<li className='list'>Adding Audio to a Sequence</li>
            <li className='list'>On Your Own: Trimming the Ends of the Video Clips</li>
            <li className='list'>Creating Ending Credits Using the Essential Graphics Panel</li>
            <li className='list'>Adding Default Transitions to a Sequence</li>
            <li className='list'>Using the Audio Mixer to Adjust Volume</li>
            <li className='list'>Creating the Introduction for the Video</li>
            <li className='list'>Combining Sequences</li>
            <li className='list'>Exporting the Completed Video</li>
            <li className='list'>Credits and References</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
        <p className='panel-title'>LEARNING OBJECTIVES</p>
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>understand terminology used in video editing</li>
          <li className='list'>create, edit, and combine sequences</li>
          <li className='list'>edit and combine audio, video, and still images</li>
          <li className='list'>create titles and credits for videos</li>
          <li className='list'>publish a video to a format suitable for web uses</li>
          <li className='list'>Types of video editing, and its uses</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFour">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
        <p className='panel-title'>EDIUS Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is EDIUS ?</li>
          <li className='list'>EDIUS Interface</li>
          <li className='list'>Important Settings</li>
          <li className='list'>Individual Layout</li>
          <li className='list'>Importing and recording material</li>
          <li className='list'>Video I/O via specific hardware</li>
          <li className='list'>Working with the Bin window</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFive">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
        <p className='panel-title'>EDIUS Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>Working in the timeline</li>
          <li className='list'>Adding transitions</li>
          <li className='list'>Title basics</li>
          <li className='list'>Adding music from Audio CD</li>
          <li className='list'>Working with Sync Lock</li>
          <li className='list'>Exporting to disc, AVCHD and file</li>
          <li className='list'>Tips and tricks for editing</li>
        </ul>
      </div>
    </div>
  </div>
          </div>
        </div>

        <div className="table-header">
	<h4><u><b>COURSE DETAILS :</b></u></h4>
<table className="table">
  <thead>
	<tr>
	<th colSpan="2" className="heading">VIDEO EDITING</th>
	</tr>
  </thead>
  <tbody>
<tr>
	<th>Overview</th>
	<td>This Adobe On-Demand class will cover have the same topics elearning topics that are covered in the Adobe Premiere Pro Core Skills: Level 1 and Level 2 classes through the elearning web edition of the text. This class also includes expanded Photoshop tutorials and related labs which are designed to reinforce new skills and prepare the user for the Adobe ACA Certification exam for Photoshop. It is not required that the student take the exams.
		</td>
</tr>
<tr>
	<th>THE BASICS Premiere Pro</th>
	<td>Premiere Pro is a professional video editing program that allows you to edit video from a number of different sources and publish edited videos to many different formats.  In this training, you'll be creating a video highlighting a selection of different dances, and in the process you'll gain familiarity with the Premiere Pro interface and learn how to perform a number of different editing tasks. </td>
</tr>
<tr>
	<th>EDIUS</th>
	<td>You will learn everything you need to know for a successful start with EDIUS, regardless if you are a new user or if you are switching from another editing platform.</td>
</tr>
</tbody>
</table>
</div>

        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Videoediting